import React from 'react';
import moment from 'moment-timezone';
import 'moment/locale/de';
import { ApolloProvider } from 'react-apollo';
import { HashRouter, Route, Switch } from 'react-router-dom';
import { MuiPickersUtilsProvider } from 'material-ui-pickers';
import MomentUtils from '@date-io/moment';

import indexRoutes from 'routes/index.jsx';

import 'assets/scss/material-dashboard-pro-react.css?v=1.4.0';
import { AuthProvider } from './auth/AuthContext';
import client from './graphql/client';
import { createBrowserHistory } from 'history';
import { TIME_ZONE } from './i18n/config';

const hist = createBrowserHistory();
moment.locale('de');
moment.tz.setDefault(TIME_ZONE);

export default function() {
  return (
    <ApolloProvider client={client}>
      <AuthProvider>
        <MuiPickersUtilsProvider
          utils={MomentUtils}
          locale={'de'}
          moment={moment}
        >
          <HashRouter history={hist}>
            <Switch>
              {indexRoutes.map((prop, key) => {
                return (
                  <Route
                    path={prop.path}
                    component={prop.component}
                    key={key}
                  />
                );
              })}
            </Switch>
          </HashRouter>
        </MuiPickersUtilsProvider>
      </AuthProvider>
    </ApolloProvider>
  );
}



// WEBPACK FOOTER //
// ./src/App.js